export const SGTIcon = ({ width = 32, height = 32 }) => (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_431_20510)">
<path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="url(#paint0_linear_431_20510)"/>
<path d="M14.5719 10.3281V12.3111H8.75754C7.73221 12.3111 7.27861 12.8657 7.27861 13.6556C7.27861 14.3447 7.63141 15.0001 8.95914 15.0001H11.6143C14.7066 15.0001 15.429 16.7143 15.429 18.3444C15.429 20.2601 14.4039 21.6719 11.8159 21.6719H5.49728V19.6889H11.8831C12.9586 19.6889 13.4461 19.1007 13.4461 18.2772C13.4461 17.538 13.0597 16.8657 11.6645 16.8657H9.02608C6.00101 16.8657 5.29541 15.1684 5.29541 13.5887C5.29541 11.7065 6.30368 10.3284 8.82448 10.3284L14.5719 10.3281Z" fill="white"/>
<path d="M26.1001 10.3281V12.3111H21.4281C19.2435 12.3111 18.2857 13.4033 18.2857 16.0081C18.2857 18.5961 19.2267 19.6884 21.4281 19.6884H23.3105C24.4195 19.6884 24.8902 19.0161 24.8902 18.0919C24.8902 17.1844 24.4195 16.6465 23.4955 16.6465H20.9747V14.9156H23.6971C25.7137 14.9156 26.7051 16.1591 26.7051 18.1255C26.7051 20.1084 25.7137 21.6713 23.1763 21.6713H21.4283C18.1179 21.6713 16.3027 19.806 16.3027 16.0081C16.3027 12.1935 18.1345 10.3281 21.4283 10.3281H26.1001Z" fill="white"/>
</g>
<defs>
<linearGradient id="paint0_linear_431_20510" x1="16" y1="32" x2="16" y2="0" gradientUnits="userSpaceOnUse">
<stop stop-color="#E6665C"/>
<stop offset="0.2" stop-color="#A5469A"/>
<stop offset="0.51" stop-color="#603193"/>
<stop offset="0.72" stop-color="#454B9F"/>
<stop offset="1" stop-color="#0F8ACB"/>
</linearGradient>
<clipPath id="clip0_431_20510">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>

  );